module.exports = __webpack_public_path__ + "img/hyundai_grandeurig.2b33abe5.jpg";